import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { createStructuredSelector } from "reselect"
import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectDivisionsAvailable,
  makeSelectIsErrorStatus,
  makeSelectIsLoading,
  makeSelectIsMeasureProcess,
  makeSelectMeasureGeneral,
  makeSelectMeasureColorRange,
  makeSelectMeasureTotal,
  makeSelectIsLoadingTotal,
  makeSelectMeasureConfig,
  makeSelectIsSectorDataAvailable,
  makeSelectIsLoadingSaveConfig,
  makeSelectUserType,
  makeSelectCompanySectors,
  makeSelectCompanySector,
  makeSelectCompanySectorsGlobal,
  makeSelectDivisionsData,
} from "./selectors"
import {
  getStatusWatcher,
  getMeasureColorRangeWatcher,
  getMeasureTotalWatcher,
  saveConfigBenchmarkWatcher,
} from "./actions"
import "./index.less"

import { Empty, Spin, Tabs, Tag, Popover } from "antd"
import {
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
  isAmbassadorOrLeaderActive,
} from "../../../utils/storage"
import empty_meditions from "images/empty_reports_home.svg"
import {
  MEASURE_STATUS,
  SURVEY_CALCULATION_TYPE,
  TYPE_SURVEY,
} from "../../../utils/constants"
import { validate } from "../../../utils/functions"
import SelectHR from "../../../components/Select"
import MeasurementColorRange from "../../../components/MeasurementColorRange"
import ClimateMeasurement from "../../components/ClimateMeasurement"
import EngagementMeasurement from "../../components/EngagementMeasurement"
import LeadershipMeasurement from "../../components/LeadershipMeasurement"
import { getMeditionsAvailableActionsWatcher } from "../ReportHeaderV2/actions"
import DrawerConfigBenchmark from "../../components/DrawerConfigBenchmark"
import { get } from "lodash"
import EmptyStateAmbassador from "../ReportAmbassador/components/EmptyStateAmbassador"
import EmptyStateAnonymity from "./components/EmptyStateAnonymity"

export function ReportAdmin(props) {
  const didMountRef = useRef(false)
  const lastStatusParamsRef = useRef(null)

  const [idDivisionSelected, setDivisionSelected] = useState(props.divisionID)
  const [idDivisionParent] = useState(props.parentDivisionID)
  const [idSegmentSelected, setIdSegmentSelected] = useState(props.segmentID)

  const triggerStatusAndActions = (idMeasure, idDivision, idSegment) => {
    const normalizedSegment = idSegment === 0 ? null : idSegment
    const normalizedDivision = idDivision

    const newParams = {
      id_measure: idMeasure,
      id_division: normalizedDivision,
      id_segment: normalizedSegment,
    }

    if (
      lastStatusParamsRef.current &&
      JSON.stringify(lastStatusParamsRef.current) === JSON.stringify(newParams)
    ) {
      return
    }

    lastStatusParamsRef.current = newParams

    const { history, getStatus, getAvailableActions } = props

    let url = history.location.pathname
    if (validate.exist(normalizedDivision)) {
      url += `?id_division=${normalizedDivision}`
    }
    if (validate.exist(normalizedSegment)) {
      url += url.includes("?")
        ? `&id_segment=${normalizedSegment}`
        : `?id_segment=${normalizedSegment}`
    }
    history.push(url)

    const isExclude =
      LOCAL_CHECKBOX_EXCLUDE() === "true" &&
      LOCAL_ISOLATED_METRICS() === "true"

    getStatus({
      isHome: true,
      id_measure: idMeasure,
      history,
      isExclude,
      params: newParams,
    })

    getAvailableActions({
      measure_id: idMeasure,
      id_division: normalizedDivision,
      id_segment: normalizedSegment,
    })
  }

  useEffect(() => {
    if (!validate.exist(props.idMeasure)) return

    if (!validate.exist(props.divisionID)) setDivisionSelected(null)
    if (!validate.exist(props.segmentID)) setIdSegmentSelected(null)

    props.getMeasureColorRange({ measure: props.idMeasure })

    triggerStatusAndActions(
      props.idMeasure,
      props.divisionID,
      props.segmentID
    )
  }, [props.idMeasure])

  useEffect(() => {
    if (props.measureGeneral?.id_measure) {
      props.onMeasureGeneralSelected(props.measureGeneral)
    }
  }, [props.measureGeneral?.id_measure])

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true
      return
    }

    const divisionChanged = idDivisionSelected !== props.divisionID
    const segmentChanged = idSegmentSelected !== props.segmentID

    if (divisionChanged || segmentChanged) {
      triggerStatusAndActions(
        props.idMeasure,
        idDivisionSelected,
        idSegmentSelected
      )
    }
  }, [
    idDivisionSelected,
    idSegmentSelected,
    props.divisionID,
    props.segmentID,
  ])

  const renderEmptyStateLeader = () => {
    const { userType, measureGeneral, measureTotal } = props
    return (
      <EmptyStateAmbassador
        userType={userType}
        measureGeneral={measureGeneral}
        measureTotal={measureTotal}
        measureEngagement={measureTotal}
      />
    )
  }

  const renderEmptyStateAnonymity = () => {
    const { userType, measureGeneral, measureTotal } = props
    return (
      <EmptyStateAnonymity
        userType={userType}
        measureGeneral={measureGeneral}
        measureTotal={measureTotal}
        measureEngagement={measureTotal}
      />
    )
  }

  const renderEmptyStateAdministrator = () => {
    const no_process = !(props.measureGeneral && props.measureGeneral.percent)

    return (
      <div style={{ padding: "1rem 2rem 2rem" }}>
        <Empty
          style={{ color: "#828282" }}
          image={empty_meditions}
          description={
            <span style={{ margin: "24px auto 0", maxWidth: 480, display: "block" }}>
              <span style={{ fontWeight: 600, fontSize: 16, display: "block" }}>
                <div>
                  {no_process
                    ? "La medición aún no ha sido procesada"
                    : "No cuentas con una medición reciente"}
                </div>
              </span>
              <span style={{ marginTop: 10, display: "block" }}>
                <div>
                  Recuerda que puedes ver el resultado de mediciones anteriores
                  desde la sección <b>Historial de mediciones.</b>
                </div>
              </span>
            </span>
          }
          className="ReportHome-empty-fix"
        />
      </div>
    )
  }

  const renderContent = (typeMeasurement) => {
    const {
      idMeasure,
      measureGeneral,
      measureTotal,
      history,
      isLoadingTotal,
      userType,
      divisionsData
    } = props

    if (isLoadingTotal) {
      return (
        <div className="loadingSpin">
          <Spin />
        </div>
      )
    }

    const validationFirstEmptyState =
      measureTotal === null || get(userType, "is_empty", true)

    if (validationFirstEmptyState) {
      if (validRole({ role: [1, 2, 3, 4] })) {
        return renderEmptyStateAdministrator()
      }
    }

    if (!get(userType, "anonymity_check.valid", true)) {
      return renderEmptyStateAnonymity()
    }

    if (
      isAmbassadorOrLeaderActive() &&
      (validationFirstEmptyState ||
        [
          MEASURE_STATUS.in_progress.id_measure_status,
          MEASURE_STATUS.finished.id_measure_status,
        ].includes(get(measureGeneral, "id_measure_status", 0)))
    ) {
      return renderEmptyStateLeader()
    }

    switch (typeMeasurement) {
      case TYPE_SURVEY.climate.slugSurveyType:
        return (
          <ClimateMeasurement
            typeMeasurement={typeMeasurement}
            idMeasure={idMeasure}
            measureTotal={measureTotal}
            measureGeneral={measureGeneral}
            idDivisionSelected={idDivisionSelected}
            idDivisionParent={idDivisionParent}
            selectedSegment={idSegmentSelected}
            divisionsData={divisionsData}
          />
        )
      case TYPE_SURVEY.engagement.slugSurveyType:
        return (
          <EngagementMeasurement
            typeMeasurement={typeMeasurement}
            idMeasure={idMeasure}
            history={history}
            measureGeneral={measureGeneral}
            measureTotal={measureTotal}
            idDivisionSelected={idDivisionSelected}
            idDivisionParent={idDivisionParent}
            selectedSegment={idSegmentSelected}
          />
        )
      case TYPE_SURVEY.leadership.slugSurveyType:
        return (
          <LeadershipMeasurement
            typeMeasurement={typeMeasurement}
            idMeasure={idMeasure}
            measureTotal={measureTotal}
            measureGeneral={measureGeneral}
            selectedSegment={idSegmentSelected}
          />
        )
    }

    return <div>render data</div>
  }

  const renderSelectDivision = (typeMeasurement) => {
    const { divisionsAvailable } = props
    if (typeMeasurement === TYPE_SURVEY.leadership.slugSurveyType) {
      return null
    }
    return (
      <div className="reportAdmin__Header--options--filterDivisions">
        <span>División</span>
        <SelectHR
          allowClear
          value={idDivisionSelected}
          options={divisionsAvailable}
          placeholder="Seleccionar división"
          style={{ width: 200 }}
          label="name"
          labelKey="id_division"
          onChange={(selectedDivision) => {
            selectedDivision = selectedDivision
              ? selectedDivision.id_division
              : null
            setDivisionSelected(
              selectedDivision ? parseInt(selectedDivision) : null
            )
          }}
        />
      </div>
    )
  }

  const renderButtonConfigBenchmark = (typeMeasurement) => {
    if (typeMeasurement === TYPE_SURVEY.leadership.slugSurveyType) return null

    const {
      measureGeneral,
      measureConfig,
      isSectorDataAvailable,
      saveConfigBenchmark,
      idMeasure,
      isLoadingSaveConfig,
      companySectors,
      companySectorsGlobal,
      companySector,
    } = props

    const hiddenConfig = [5, 4, 3].includes(measureGeneral.id_survey_type)
    if (hiddenConfig) return null

    return (
      <DrawerConfigBenchmark
        measureConfig={measureConfig}
        isLoadingSaveConfig={isLoadingSaveConfig}
        isSectorDataAvailable={isSectorDataAvailable}
        companySectors={companySectors}
        companySectorsGlobal={companySectorsGlobal}
        companySector={companySector}
        measureGeneral={measureGeneral}
        idMeasure={idMeasure}
        saveConfigBenchmark={(data) =>
          saveConfigBenchmark({ ...data, history: props.history })
        }
      />
    )
  }

  const getTabSelected = () => {
    return !idSegmentSelected ? "0" : idSegmentSelected.toString()
  }

  const getSegmentsForTitle = (segments = []) => {
    if (isAmbassadorOrLeaderActive()) return ""
    if (getTabSelected() === "0" && segments.length > 1) return " - General"
    if (getTabSelected() !== "0" && segments.length > 1) {
      const index = parseInt(getTabSelected())
      const segment = segments.find((x) => x.id_segment === index)
      return ` - ${segment.name}`
    }
    if (segments.length === 1) return ` - ${segments[0].name}`
    return ""
  }

  const renderHeaderReport = (typeMeasurement) => {
    const {
      currentMeasure,
      measureColorRange,
      measureTotal,
      userType,
      measureGeneral,
    } = props
    const validationFirstEmptyState =
      measureTotal === null ||
      get(userType, "is_empty", true) ||
      !get(userType, "anonymity_check", true)

    const isLeadershipOrAmbassador = isAmbassadorOrLeaderActive()
    const renderNameReport =
      measureGeneral.id_survey_type === 2 ? "Liderazgo" : currentMeasure.name

    return (
      <div className="reportAdmin__Header">
        {measureGeneral.segments.length > 1 && !isLeadershipOrAmbassador && (
          <div className="reportAdmin__Tabs">
            <Tabs
              activeKey={getTabSelected()}
              onChange={(key) => {
                setIdSegmentSelected(parseInt(key) === 0 ? null : parseInt(key))
              }}>
              <Tabs.TabPane tab="General" key={0} />
              {measureGeneral.segments.map((segment) => (
                <Tabs.TabPane tab={segment.name} key={segment.id_segment} />
              ))}
            </Tabs>
          </div>
        )}
        <div className="reportAdmin__Header--name">
          <div className="reportAdmin__Header--name--container">
            <div className="reportAdmin__Header--name--container--title">
              {renderNameReport} {getSegmentsForTitle(measureGeneral.segments)}
            </div>
            {measureGeneral.id_measure_type === 2 && (
              <Popover
                overlayStyle={{ width: "400px" }}
                content="La medición no es representativa de toda la población...">
                <Tag color="blue" style={{ fontWeight: 600, marginLeft: "10px" }}>
                  Pulso
                </Tag>
              </Popover>
            )}
          </div>
          <MeasurementColorRange measureColorRange={measureColorRange} />
        </div>
        <div className="reportAdmin__Header--options">
          {!validationFirstEmptyState && renderSelectDivision(typeMeasurement)}
          {!validationFirstEmptyState &&
            renderButtonConfigBenchmark(typeMeasurement)}
        </div>
      </div>
    )
  }

  if (props.isLoading) {
    return (
      <div className="reportAdmin">
        <div className="loadingSpin">
          <Spin />
        </div>
      </div>
    )
  }

  if (!validate.exist(props.measureGeneral)) return null

  const typeMeasurement = props.measureGeneral.id_survey_type === TYPE_SURVEY.leadership.idSurveyType
    ? TYPE_SURVEY.leadership.slugSurveyType
    : props.measureGeneral.is_engagement
    ? TYPE_SURVEY.engagement.slugSurveyType
    : TYPE_SURVEY.climate.slugSurveyType

  return (
    <div className="reportAdmin" style={{ ...(typeof window.Intercom !== "undefined" &&
      window.self === window.top && {
      marginBottom: "100px"}) }}>
      {renderHeaderReport(typeMeasurement)}
      {renderContent(typeMeasurement)}
    </div>
  )
}

ReportAdmin.propTypes = {
  parentDivisionID: PropTypes.number,
  divisionID: PropTypes.number,
  isLoading: PropTypes.bool,
  history: PropTypes.object,
  idMeasure: PropTypes.number,
  currentMeasure: PropTypes.object,
  isMeasureProcess: PropTypes.bool,
  divisionsAvailable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureGeneral: PropTypes.object,
  measureTotal: PropTypes.object,
  measureConfig: PropTypes.object,
  isErrorStatus: PropTypes.bool,
  measureColorRange: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  getStatus: PropTypes.func,
  getMeasureColorRange: PropTypes.func,
  getMeasureTotal: PropTypes.func,
  isLoadingTotal: PropTypes.bool,
  getAvailableActions: PropTypes.func,
  saveConfigBenchmark: PropTypes.func,
  isLoadingSaveConfig: PropTypes.bool,
  divisionsData: PropTypes.object

}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  isMeasureProcess: makeSelectIsMeasureProcess(),
  divisionsAvailable: makeSelectDivisionsAvailable(),
  measureTotal: makeSelectMeasureTotal(),
  measureConfig: makeSelectMeasureConfig(),
  measureGeneral: makeSelectMeasureGeneral(),
  isErrorStatus: makeSelectIsErrorStatus(),
  measureColorRange: makeSelectMeasureColorRange(),
  isLoadingTotal: makeSelectIsLoadingTotal(),
  isLoadingSaveConfig: makeSelectIsLoadingSaveConfig(),
  isSectorDataAvailable: makeSelectIsSectorDataAvailable(),
  companySectors: makeSelectCompanySectors(),
  companySectorsGlobal: makeSelectCompanySectorsGlobal(),
  companySector: makeSelectCompanySector(),
  userType: makeSelectUserType(),
  divisionsData: makeSelectDivisionsData(),
})

function mapDispatchToProps(dispatch) {
  return {
    getStatus: (params) => dispatch(getStatusWatcher(params)),
    getMeasureColorRange: (params) => dispatch(getMeasureColorRangeWatcher(params)),
    getMeasureTotal: (params) => dispatch(getMeasureTotalWatcher(params)),
    getAvailableActions: (params) => dispatch(getMeditionsAvailableActionsWatcher(params)),
    saveConfigBenchmark: (params) => dispatch(saveConfigBenchmarkWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "reportAdmin", reducer })
const withSaga = injectSaga({ key: "reportAdmin", saga })

export default compose(withReducer, withSaga, withConnect)(ReportAdmin)
